<template>
	<main class="mypage signin">
		<div class="siginin_form">
			<h6>비밀번호 찾기</h6>
			<div class="c_fieldArea">
				<FieldLayout
					title="아이디"
					:success="member_id_valid ? MESSAGE_ID_VERIFICATION_COMPLETED : ''"
					:error="errors.member_id || errors.member_id_valid"
					@input="
						() => {
							if (member_id_valid) member_id_valid = false;
						}
					"
				>
					<InputText v-model="member_id" :placeholder="INPUT_ID" />
					<button class="c_button primary-fill radius-x-small" :disabled="!member_id" @click="onClickCheckId">
						확인
					</button>
				</FieldLayout>
				<FieldPhoneValidate
					v-model:phoneNum="member_cell"
					v-model:isPhoneValid="member_cell_valid"
					required
					phone-type="Check"
					:phoneNum_error="errors.member_cell"
					:isPhoneValid_error="errors.member_cell_valid"
					type="join"
				/>
				<button
					class="c_button primary-fill"
					:disabled="!member_id || !member_cell || !member_id_valid"
					@click="onClickCheckMember"
				>
					다음
				</button>
			</div>
		</div>
	</main>
</template>

<script setup lang="ts">
// core
import { useRouter } from 'vue-router';
// validation
import { useForm } from 'vee-validate';
import * as yup from 'yup';

// api
import { useCheckIdDuplicateApi, useFindMemberPasswordApi } from '@/api/auth';
// component
import InputText from '@/components/atom/input/InputText.vue';
import FieldLayout from '@/components/form/FieldLayout.vue';
import FieldPhoneValidate from '@/components/form/FieldPhoneValidate.vue';
// constant
import { phoneRegex } from '@/constants/regex';
import {
	COMPANY_TITLE,
	ERROR_REQUIRED_FIELD,
	INPUT_ID,
	MESSAGE_ID_DUPLICATE_CHECK_COMPLETED,
	MESSAGE_ID_VERIFICATION_COMPLETED,
	MESSAGE_PHONE_VERIFICATION_COMPLETED,
	MESSAGE_VERIFY_PHONE_NUMBER,
	PHONE_NUMBER_MISMATCH,
	UNREGISTERED_ID,
} from '@/constants/title';
// store
import { usePopupStore } from '@/stores/popup';

// -----variable-----
const popupStore = usePopupStore();
const router = useRouter();

// -----validation-----
const { errors, defineField, setFieldError, validate } = useForm({
	validationSchema: yup.object({
		member_id: yup.string().required(ERROR_REQUIRED_FIELD),
		member_id_valid: yup.boolean().isTrue(MESSAGE_ID_DUPLICATE_CHECK_COMPLETED),
		member_cell: yup
			.string()
			.required(ERROR_REQUIRED_FIELD)
			.min(13, '')
			.matches(phoneRegex, MESSAGE_VERIFY_PHONE_NUMBER),
		member_cell_code: yup.string(),
		member_cell_valid: yup.boolean().isTrue(MESSAGE_PHONE_VERIFICATION_COMPLETED),
	}),
	initialValues: {
		member_id: '',
		member_id_valid: false,
		member_cell: '',
		member_cell_valid: false,
	},
});
const [member_id] = defineField('member_id'); //아이디
const [member_id_valid] = defineField('member_id_valid'); // 아이디 중복확인 여부
const [member_cell] = defineField('member_cell'); //휴대폰번호
const [member_cell_valid] = defineField('member_cell_valid'); // 휴대폰번호 인증 여부 (아이디찾기)

// -----api-----
const { mutateAsync: checkIdDuplicate } = useCheckIdDuplicateApi();
const { mutateAsync: findMemberPassword } = useFindMemberPasswordApi();

// -----function-----
// 아이디와 휴대폰이 해당 회원있는 지 유무
const onClickCheckMember = async () => {
	const { valid } = await validate();
	if (!valid) {
		return;
	}

	const res = await findMemberPassword({
		member_contact: member_cell.value,
		member_id: member_id.value,
	});

	if (res.data.success) {
		router.push({
			name: 'auth/change-pw',
			query: {
				id: member_id.value,
			},
		});
	} else {
		popupStore.openPopup({
			content: COMPANY_TITLE,
			subtext: PHONE_NUMBER_MISMATCH,
		});
	}
};
//아이디 등록 유무 확인
const onClickCheckId = async () => {
	const res = await checkIdDuplicate({ member_id: member_id.value });
	if (res.data.success) {
		setFieldError('member_id', UNREGISTERED_ID);
	} else {
		member_id_valid.value = true;
	}
};
</script>

<style lang="scss" scoped>
.signin {
	max-width: 40rem;
	padding-bottom: var(--bottomMenu-height);
	.siginin_form {
		display: flex;
		flex-direction: column;
		width: 100%;
		gap: 4rem;
		.register {
			height: 4.8rem;
			font-size: var(--font-s-regular);
			font-weight: var(--font-w-medium);
		}
		.c_fieldArea {
			.phone_number {
				display: flex;
				flex-direction: column;
				gap: 1rem;
			}
			.c_button {
				height: 4.8rem;
			}
		}
	}
}
</style>
